/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListMyInvitationsQueryResponse, ListMyInvitations400, ListMyInvitations401, ListMyInvitations403, ListMyInvitations404, ListMyInvitations409, ListMyInvitations500 } from "../../types/staffController/ListMyInvitations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListMyInvitationsUrl() {
  const res = { method: 'GET', url: `/api/invitations/me` as const }
  return res
}

/**
 * @summary List the signed-in user's pending invitations
 * {@link /api/invitations/me}
 */
export async function listMyInvitations(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListMyInvitationsQueryResponse, ResponseErrorConfig<ListMyInvitations400 | ListMyInvitations401 | ListMyInvitations403 | ListMyInvitations404 | ListMyInvitations409 | ListMyInvitations500>, unknown>({ method : "GET", url : getListMyInvitationsUrl().url.toString(), ... requestConfig })
  return res.data
}